import React from "react";
import { Outlet } from "react-router-dom";

export function DataCollectionsOutlet() {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
}


